(() => {
  'use strict';

  const BADGE_SELECTOR = '.jdgm-preview-badge .jdgm-prev-badge';
  const TEXT_SELECTOR = '.jdgm-prev-badge__text';
  const observedBadges = new WeakSet();

  function normalizeBadge(badge) {
    const count = (badge.getAttribute('data-number-of-reviews') || '').trim();
    const text = badge.querySelector(TEXT_SELECTOR);

    if (!text || !/^\d+$/.test(count) || count === '0') return;

    const label = count === '1' ? '1 review' : `${count} reviews`;
    if (text.textContent === label && text.hasAttribute('data-sc-review-count-ready')) return;

    text.textContent = label;
    text.setAttribute('data-sc-review-count-ready', '');
  }

  function observeBadge(badge) {
    if (observedBadges.has(badge)) {
      normalizeBadge(badge);
      return;
    }

    observedBadges.add(badge);
    new MutationObserver(() => normalizeBadge(badge)).observe(badge, {
      attributes: true,
      attributeFilter: ['data-number-of-reviews'],
      childList: true,
      subtree: true,
      characterData: true,
    });
    normalizeBadge(badge);
  }

  function discoverBadges(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches(BADGE_SELECTOR)) observeBadge(node);
    node.querySelectorAll(BADGE_SELECTOR).forEach(observeBadge);
  }

  const discoveryObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(discoverBadges);
    });
  });

  discoveryObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  discoverBadges(document.documentElement);
})();
